import { CodingCriteria, CodingValueCriteria } from "../../models/criteria";

export function instanceOfCodingCriteria(obj: any): obj is CodingCriteria {
  return obj && typeof obj === "object" && "coding" in obj;
}

export function instanceOfCodingValueCriteria(obj: any): obj is CodingValueCriteria {
  return obj && typeof obj === "object" && "base_coding" in obj && "value_coding" in obj;
}
